// Blast WhatsApp tab (MingZe only): instances, campaign with send interval, tick members, progress.
import React from "react";
import { Alert, Button, Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";
import { CampaignHistory, CampaignProgress, MemberPicker, MessageComposer, PageShell, WhatsappInstances, WhatsappSafetyTips } from "./memberComponents.jsx";
import { formatPhone, isOwner, memberPost } from "./memberApi.js";

const EMPTY = { name: '', content: '', imageurl: '', selected: {} };

// Renders WhatsApp *bold* _italic_ ~strike~ for the preview bubble.
export const WhatsappPreview = ({ text, imageurl }) => {
  const html = (text || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/\{name\}/g, 'Ali').replace(/\{memberid\}/g, 'MZ000001')
    .replace(/\*([^*\n]+)\*/g, '<b>$1</b>').replace(/_([^_\n]+)_/g, '<i>$1</i>').replace(/~([^~\n]+)~/g, '<s>$1</s>');
  return (
    <div style={{ background: '#e5ddd5', padding: 16, borderRadius: 8, minHeight: 120 }}>
      <div style={{ background: '#dcf8c6', borderRadius: 8, padding: 8, maxWidth: 320, marginLeft: 'auto', boxShadow: '0 1px 1px rgba(0,0,0,0.1)' }}>
        {imageurl ? <img src={imageurl} alt="" style={{ width: '100%', borderRadius: 6, marginBottom: 6 }} /> : null}
        <div style={{ whiteSpace: 'pre-wrap', fontSize: 14, color: '#111' }} dangerouslySetInnerHTML={{ __html: html || '<span style="color:#999">Message preview</span>' }} />
      </div>
    </div>
  );
};

class BlastWhatsapp extends React.Component {
  state = Object.assign({
    tab: 'new', members: [], loading: true, instances: [], instance: '', intervalsec: 15,
    error: '', sending: false, progressId: null, testto: '', testing: false, testresult: null,
  }, EMPTY);

  componentDidMount() {
    if (!isOwner()) return;
    memberPost('member-list').then(json => this.setState({ loading: false, members: json.success == 1 ? json.members : [] }));
  }

  onInstances = (instances) => {
    const connected = instances.filter(i => i.state === 'open');
    const stillThere = connected.some(i => i.instancename === this.state.instance);
    this.setState({ instances, instance: stillThere ? this.state.instance : (connected[0] ? connected[0].instancename : '') });
  };

  // Members from all branches can be ticked.
  canSelect = (m) => m.status === 'Active' && m.whatsappconsent == 1 && !!m.phone;
  reasonOf = (m) => m.status !== 'Active' ? 'Inactive' : 'Opted out';

  send = () => {
    const s = this.state;
    const ids = Object.keys(s.selected);
    if (!s.instance) { this.setState({ error: 'Please register and connect a WhatsApp instance first' }); return; }
    if (!s.name.trim() || !s.content.trim()) { this.setState({ error: 'Please fill in campaign name and message' }); return; }
    if (parseInt(s.intervalsec, 10) < 5) { this.setState({ error: 'Interval must be at least 5 seconds' }); return; }
    if (ids.length === 0) { this.setState({ error: 'Please tick at least one member' }); return; }
    if (!window.confirm('Send this WhatsApp message to ' + ids.length + ' member(s) now?')) return;
    this.setState({ sending: true, error: '' });
    memberPost('campaign-send', {
      channel: 'whatsapp', name: s.name.trim(), content: s.content, imageurl: s.imageurl, instancename: s.instance,
      intervalsec: s.intervalsec, memberids: JSON.stringify(ids),
    }).then(json => {
      if (json.success == 1) this.setState(Object.assign({ sending: false, progressId: json.campaignid }, EMPTY));
      else this.setState({ sending: false, error: json.message });
    });
  };

  test = () => {
    const s = this.state;
    if (!s.testto.trim() || !s.instance) return;
    this.setState({ testing: true, testresult: null });
    memberPost('test-send', { channel: 'whatsapp', to: s.testto.trim(), instancename: s.instance, content: s.content, imageurl: s.imageurl })
      .then(json => this.setState({ testing: false, testresult: json }));
  };

  reuse = (c) => this.setState({ tab: 'new', name: c.name + ' (copy)', content: c.content, imageurl: c.imageurl, intervalsec: c.intervalsec, selected: {} });

  render() {
    const s = this.state;
    const connected = s.instances.filter(i => i.state === 'open');
    const count = Object.keys(s.selected).length;
    const interval = parseInt(s.intervalsec, 10) || 0;
    // Average gap is interval + 25% random jitter added by the server.
    const minutes = Math.ceil(count * interval * 1.25 / 60);
    return (
      <PageShell title="Blast WhatsApp" ownerOnly>
        <Nav tabs className="mb-4">
          {[['new', 'New Campaign'], ['instances', 'WhatsApp Instances'], ['history', 'Campaign History']].map(([key, label]) => (
            <NavItem key={key}><NavLink href="#" active={s.tab === key} onClick={e => { e.preventDefault(); this.setState({ tab: key }); }}>{label}</NavLink></NavItem>
          ))}
        </Nav>

        <div style={{ display: s.tab === 'instances' ? 'block' : 'none' }}>
          <WhatsappInstances onLoad={this.onInstances} />
        </div>

        {s.tab === 'history' ? <CampaignHistory key={s.progressId || 'h'} channel="whatsapp" onReuse={this.reuse} onResume={id => this.setState({ progressId: id })} /> : null}

        {s.tab === 'new' ? (
          <>
            <WhatsappSafetyTips />
            {connected.length === 0 ? (
              <Alert color="warning">No connected WhatsApp yet. Go to <a href="#" onClick={e => { e.preventDefault(); this.setState({ tab: 'instances' }); }}><b>WhatsApp Instances</b></a> to register and scan the QR code.</Alert>
            ) : null}
            <Row>
              <Col lg="7">
                <h4>1. Message</h4>
                <Row>
                  <Col md="6"><FormGroup><Label className="form-control-label">Campaign name (internal)</Label>
                    <Input value={s.name} onChange={e => this.setState({ name: e.target.value })} placeholder="e.g. Raya Promo 2026" maxLength={150} /></FormGroup></Col>
                  <Col md="6"><FormGroup><Label className="form-control-label">Send from WhatsApp</Label>
                    <Input type="select" value={s.instance} onChange={e => this.setState({ instance: e.target.value })}>
                      {connected.length === 0 ? <option value="">No connected instance</option> : null}
                      {connected.map(i => <option key={i.instancename} value={i.instancename}>{i.displayname}{i.number ? ' (' + formatPhone(i.number) + ')' : ''}</option>)}
                    </Input></FormGroup></Col>
                </Row>
                <FormGroup><Label className="form-control-label">WhatsApp message</Label>
                  <MessageComposer whatsapp value={s.content} onChange={content => this.setState({ content })} imageurl={s.imageurl} onImageChange={imageurl => this.setState({ imageurl })}
                    placeholder={"Hi {name} 👋\n\nWrite your promotion here..."} /></FormGroup>
                <Row>
                  <Col md="6"><FormGroup><Label className="form-control-label">Interval between messages (seconds)</Label>
                    <Input type="number" min="5" value={s.intervalsec} onChange={e => this.setState({ intervalsec: e.target.value })} />
                    <small className="text-muted">Recommended 15–30s. A random extra delay is added to lower the risk of WhatsApp blocking the number.</small></FormGroup></Col>
                  <Col md="6"><FormGroup><Label className="form-control-label">Send a test to</Label>
                    <div className="d-flex" style={{ gap: 8 }}>
                      <Input placeholder="0123456789" value={s.testto} onChange={e => this.setState({ testto: e.target.value })} />
                      <Button color="secondary" onClick={this.test} disabled={s.testing || !s.instance}>{s.testing ? <Spinner size="sm" /> : 'Test'}</Button>
                    </div></FormGroup>
                    {s.testresult ? <Alert color={s.testresult.success == 1 ? 'success' : 'danger'} className="py-2">{s.testresult.success == 1 ? 'Test message sent' : s.testresult.message}</Alert> : null}
                  </Col>
                </Row>
              </Col>
              <Col lg="5">
                <h4>Preview</h4>
                <WhatsappPreview text={s.content} imageurl={s.imageurl} />
              </Col>
            </Row>

            <h4 className="mt-4">2. Tick members to send</h4>
            {s.loading ? <Spinner /> : (
              <MemberPicker members={s.members} selected={s.selected} onChange={selected => this.setState({ selected })}
                canSelect={this.canSelect} reasonOf={this.reasonOf} contactLabel="WhatsApp" contactOf={m => formatPhone(m.phone)} />
            )}

            {s.error ? <Alert color="danger" className="mt-3">{s.error}</Alert> : null}
            <div className="d-flex justify-content-end align-items-center mt-3" style={{ gap: 16 }}>
              {count > 0 && interval > 0 ? <span className="text-muted">Estimated time: about {minutes} minute(s)</span> : null}
              <Button color="success" size="lg" onClick={this.send} disabled={s.sending || connected.length === 0}>
                {s.sending ? <Spinner size="sm" /> : 'Confirm & Send to ' + count + ' member(s)'}
              </Button>
            </div>
          </>
        ) : null}

        {s.progressId ? <CampaignProgress campaignid={s.progressId} onClose={() => this.setState({ progressId: null, tab: 'history' })} /> : null}
      </PageShell>
    );
  }
}

export default BlastWhatsapp;
